module.exports = __webpack_public_path__ + "img/chip01.5ae9a403.png";